<template>
  <Modal key="image">
    <template slot="modal__button" slot-scope="{didOpen}">
      <div class="shadow-sm rounded-md" v-if="hasImaged">
        <button
          @click="undoImage( () => {} )"
          class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 transition duration-150 ease-in-out cursor-pointer"
          tabindex="2"
        >
          Undo Image
        </button>
      </div>
      <div class="shadow-sm rounded-md" v-else>
        <button
          @click="didOpen"
          class="inline-flex items-center px-2 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 transition duration-150 ease-in-out cursor-pointer"
          tabindex="2"
        >
          <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
            <use href="/images/regular.svg#image"></use>
          </svg>
        </button>
      </div>
    </template>
    <template slot="modal__body" slot-scope="{didClose}">
      <div>
        <div class="mt-3 text-center sm:mt-5">
          <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
            Send an Image
          </h3>
          <div class="mt-2">
            <p class="text-sm leading-5 text-gray-500">
              Files ending in .jpg .jpeg .gif .png are all okay 👍
            </p>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <div v-if="!hasImaged && !isImaging">
          <FilePicker
            id="message-new"
            :allowMultiple="false"
            v-on:vfp-file-added="didAddFile"
          />
        </div>
        <div v-else-if="isImaging" class="bg-gray-200 w-full align-center p-4">
          Uploading... <font-awesome-icon class="ml-2" :icon="['far', 'spinner']" spin/>
        </div>
        <div v-else-if="messageFileUrl" class="">
          <img :src="messageFileUrl" alt="" style="max-width: 300px">
        </div>
        <div class="rounded bg-red-700-600 my-4 text-white p-4" v-if="imageErrors[0]">
          <div v-for="(error, index) in imageErrors" :key="index">
            {{error.message}}
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="didClose"
          >
            Done
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="undoImage(didClose)"
          >
            Cancel
          </button>
        </span>
      </div>
    </template>
  </Modal>
</template>

<script>
import gql from 'graphql-tag'
import _get from 'lodash-es/get'
import axios from 'axios'

import Modal              from '@/components/Modal.vue'
import FilePicker         from '@/components/FilePicker.vue'


export default {
  components: {
    FilePicker,
    Modal
  },

  props: {
    hasImaged: {
      type: Boolean,
      required: true
    },
    proposedMessageFile: {
      type: Object
    },
    teamId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      imageErrors: [],
      isImaging: false
    }
  },

  computed: {
    messageFileUrl() {
      return _get(this.proposedMessageFile, 'url')
    }
  },

  methods: {
    didAddFile(fileList) {
      this.imageErrors = []
      this.isImaging = true

      var data = new FormData()
      data.append('file', fileList.item(0))
      data.append('teamId', this.teamId)

      axios.post('/file', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'auth': localStorage.getItem('cardstock_auth_token')
        }
      })
      .then(({data}) => {
        console.log("Cardstock: ImageModalInput success")
        this.$emit('input', {proposedMessageFile: data.file, hasImaged: true})
        this.isImaging = false
      })
      .catch((error) => {
        console.error("Cardstock: ImageModalInput unhandleable error")
        console.error(error)
        this.imageErrors = [{message: "Cannot connect to Cardstock"}]
        this.isImaging = false
      })
    },

    undoImage(callback) {
      if (this.proposedMessageFile) {
        this.$apollo.mutate({
          mutation: gql`
            mutation deleteMessageFile($id: ID!) {
              messageFileDelete(id: $id) {
                id
                deletedAt
              }
            }
          `,
          variables: {
            id: this.proposedMessageFile.id
          }
        }).then(({data}) => {
          console.log('Cardstock: ImageModalInput - MessageFileDelete success')
          this.$emit('input', {proposedMessageFile: null, hasImaged: false})
        }).catch( ({error}) => {
          console.error('Cardstock: ImageModalInput - MessageFileDelete failure')
          console.error(error)
          this.$emit('input', {proposedMessageFile: null, hasImaged: false})
        })
      }

      if (callback) { callback() }
    },
  }
}
</script>
